import React from 'react';
import { Header } from '../../libs/gs-component-right-rail';

interface Props {
  headerText: string;
  onClose: () => void;
  isNew: boolean;
  preview?: boolean;
  as?: string;
}

const LayoutHeader: React.FC<Props> = ({ headerText, onClose, isNew, as = '', preview }) => {
  const headerProps =
    isNew || preview
      ? {
          leftButtonText: 'Back',
          leftButtonOnClick: onClose,
        }
      : {
          onClose,
        };

  return (
    <Header as={as} {...headerProps}>
      {headerText}
    </Header>
  );
};

export default LayoutHeader;
